import React from 'react'
import PropTypes from 'prop-types'
import { FooterContainer, Heart, TextP } from './styles'
import ContactMe from './contac-me/ContactMe'

const Footer = ({ name }) => {
  return (
    <FooterContainer>
      
      <ContactMe />

      <TextP
        color="rgb(224, 228, 228)"
        fontSize=".9rem"
      >
        pablourbanohdzvizcarra@gmail.com
      </TextP>

      <TextP
        color="rgb(224, 228, 228)"
      >
        Made with <Heart src="/img/002-heart-1.svg" alt=""/> by {name}
      </TextP>

    </FooterContainer>
  )
}

Footer.propTypes = {
  name: PropTypes.string.isRequired,
}

export default Footer

